module.exports = __webpack_public_path__ + "img/jiazi.909e4e7f.gif";